/* eslint-disable */
// this file has been generated by scripts/copyTheme.js from tailwind.config.cjs
export default {
  "colors": {
    "vividTangelo": "#F26E23",
    "vermilion": "#D5441C",
    "chineseBlack": "#121016",
    "dodgerBlue": "#238FF2",
    "black": "#252629",
    "blackOlive": "#3F3B3B",
    "brightGray": "#E4E8F0",
    "pageBackgroundWhite": "#F5F4F7",
    "waterLight": "#DFF0FF",
    "waterLightHover50": "#DFF0FF80",
    "white": "#FFFFFF",
    "eerieBlack": "#18171B",
    "dimGray": "#646870",
    "pageBackgroundDark": "#212327",
    "waterLight20": "#DFF0FF33",
    "waterLightHover10": "#DFF0FF10",
    "darkCharcoal": "#313035",
    "minionYellow": "#FAE84C",
    "honoluluBlue": "#0261B6",
    "aliceBlue": "#F3FBFF",
    "munsellPurple": "#970ABA",
    "snow": "#FFF5FC",
    "redOrange": "#FF400F",
    "seashell": "#FFF6F0",
    "honeydew": "#F3FFF4",
    "yellowGreen": "#10AD20",
    "water": "#CBE6FF",
    "darkCerulean": "#194875",
    "paleViolet": "#C190FF",
    "englishViolet": "#4E435D",
    "oriolesOrange": "#F24823",
    "royalBrown": "#573431",
    "limeGreen": "#30DA41",
    "deepMossGreen": "#315237",
    "lotion": "#FAFAFA",
    "pastelBlue": "#B4BDD3",
    "platinum": "#E7E7E8",
    "davysGray": "#5A5A5A",
    "spanishGray": "#8D939A",
    "ghostWhite": "#F9F9F9",
    "blueTone": "#F0F5FF",
    "silverSand": "#BABFC8",
    "body": "#f6f9ff",
    "arsenic": "#414246",
    "americanSilver": "#CFCFD2",
    "lightCoral": "#F18888",
    "mauvelous": "#EE9C9C",
    "rajah": "#FFAB62",
    "middleYellow": "#E9BE78",
    "buff": "#F4DF82",
    "flavescent": "#FFF38B",
    "middleGreen": "#B4CD67",
    "lightGreen": "#90E298",
    "etonBlue": "#85CBA6",
    "pearlAqua": "#71C8C3",
    "cobaltBlue": "#88B3D9",
    "lightAzure": "#6EBAFE",
    "winterWizard": "#9FD7FF",
    "snowWizard": "#9DE7FF",
    "brilliantLavender": "#F2CEFF",
    "spiroDiscoBall": "#1DBFF2",
    "thistleCrayola": "#EDAEEB",
    "brightUbe": "#CBAAF6",
    "jordyBlue": "#94A6FF",
    "bone": "#DFD3BC",
    "khaki": "#C0B39B",
    "pastelGrey": "#B8C1CC"
  },
  "spacing": {
    "1": "0.8rem",
    "2": "1.6rem",
    "3": "2.4rem",
    "4": "3.2rem",
    "5": "4rem",
    "6": "4.8rem",
    "7": "5.6rem",
    "8": "6.4rem",
    "9": "7.2rem",
    "10": "8rem",
    "0.5": "0.4rem",
    "1.5": "1.2rem",
    "2.5": "2rem",
    "3.5": "2.8rem",
    "4.5": "3.6rem",
    "5.5": "4.4rem",
    "6.5": "5.2rem",
    "7.5": "6rem",
    "8.5": "6.8rem",
    "9.5": "7.6rem"
  },
  "fontSize": {
    "1016": [
      "1rem",
      "1.6rem"
    ],
    "1216": [
      "1.2rem",
      "1.6rem"
    ],
    "1316": [
      "1.3rem",
      "1.6rem"
    ],
    "1420": [
      "1.4rem",
      "2rem"
    ],
    "1424": [
      "1.4rem",
      "2.4rem"
    ],
    "1432": [
      "1.4rem",
      "3.2rem"
    ],
    "1624": [
      "1.6rem",
      "2.4rem"
    ],
    "1824": [
      "1.8rem",
      "2.4rem"
    ],
    "2432": [
      "2.4rem",
      "3.2rem"
    ],
    "sm": "1.2rem",
    "md": "1.4rem",
    "lg": "1.6rem",
    "xl": "3.2rem"
  },
  "borderColor": {
    "DEFAULT": "#E4E8F0"
  },
  "borderRadius": {
    "sm": "0.8rem",
    "md": "1.2rem",
    "lg": "1.6rem",
    "xl": "3.2rem",
    "modal": "3rem"
  },
  "backgroundImage": {
    "needHelp": "url('@shared/ui/assets/need-help-pattern.svg')"
  },
  "boxShadow": {
    "modalLight": "2px 12px 30px 0px rgba(208, 215, 225, 0.50)",
    "modalDark": "2px 12px 30px 0px rgba(18, 16, 22, 0.80)",
    "leftBarLight": "2px 0px 24px 0px rgba(180, 189, 211, 0.12)",
    "leftBarDark": "2px 0px 24px 0px rgba(18, 16, 22, 0.12)",
    "expandArrowLight": "0px 2px 4px 0px rgba(180, 189, 211, 0.25)",
    "expandArrowDark": "0px 2px 4px 0px rgba(18, 16, 22)"
  },
  "fontFamily": {
    "sans": [
      "Poppins",
      "sans-serif"
    ],
    "nunito": [
      "Nunito Sans",
      "sans-serif"
    ]
  },
  "screens": {
    "mini": {
      "min": "1024px",
      "max": "1440px"
    }
  },
  "transitionProperty": {
    "spacing": "margin, padding"
  }
}